import RelatedQuestion from './RelatedQuestion';

export default RelatedQuestion;
